import React from 'react';
import { Backdrop, Box, Button, Typography } from '../imports/muiImport';
import { NavLink, useNavigate } from 'react-router-dom';

import Login from './authPages/Login';
import OTPComponent from './otp/OTPComponent';
import Timer from '../pages/LOGIN_SIGNUP/OTP/Timer';
import { userTokenSave } from '../apiCalls/functions';
import { actionNotifier } from '../components/tostify';
import { useAuth } from '../hooks/contexts/AuthContext';
import { resendOTP, verifyLogin } from '../apiCalls/urls/urlFunction';
import { CircularProgress } from '@mui/material';

const LoginPage = () => {
    const [showOTPForm, setOTPForm] = React.useState(false);
    const [isResetOtp, setIsResetOtp] = React.useState(false);
    const [otpFormTimer, setOtpFormTimer] = React.useState(15);
    const [noOfUserOTPSend, setNoOfUserOTPSend] = React.useState(0);
    const [isUserAuthentic, setIsUserAuthentic] = React.useState({});
    const [otpFormLoading, setOtpFormLoading] = React.useState(false);
    const [isResendAvailable, setIsResendAvailable] = React.useState(false);

    const { setIsLoggedIn } = useAuth();
    const navigate = useNavigate();

    const userLoginSuccessfully = async (token) => {
        let loginToken = userTokenSave(token);

        if (loginToken) {
            // Set true User Login Status it will reflect every where
            setIsLoggedIn(true);

            // Notification remove
            actionNotifier.clearAll();
            navigate('/', { replace: true });
        }
    };

    const handleOtpVerify = async (email, otp) => {
        setOtpFormLoading(() => true);
        const payload = {
            email: isUserAuthentic?.email || null,
            otp,
        };

        if (otp?.length < 6) {
            actionNotifier.error('Please enter a valid 6-digit OTP', {
                position: 'top-left',
                autoClose: 2000,
            });
            setOTPForm(() => false);
            setOtpFormLoading(() => false);
            return;
        }

        const verifyLoginResponse = await verifyLogin(payload);
        if (!verifyLoginResponse?.status) {
            setOtpFormLoading(() => false);
            actionNotifier.error(verifyLoginResponse?.message, {
                position: 'top-left',
                autoClose: 2000,
            });
            return;
        }

        actionNotifier.success(verifyLoginResponse?.data?.message, {
            position: 'top-left',
            autoClose: 2000,
        });

        userLoginSuccessfully(verifyLoginResponse?.token);
        setOtpFormLoading(() => false);
        setTimeout(() => {
            navigate('/', { replace: true });
            setOtpFormLoading(false);
        }, 300);
        return;
    };

    const handleOtpResend = async () => {
        if (isResendAvailable) {
            const payload = {
                email: isUserAuthentic?.email,
                password: isUserAuthentic?.password,
            };
            const resendResponse = await resendOTP(payload);

            if (resendResponse?.status) {
                setNoOfUserOTPSend((prevState) => prevState + 1);
                setOtpFormTimer(() => 15);

                actionNotifier.info('OTP has been resent', { position: 'top-left', autoClose: 1000 });
            }
        } else {
            actionNotifier.warning(`Please wait for the timer to resend OTP`, {
                position: 'top-left',
                autoClose: 1000,
            });
        }
    };

    const timerEnd = () => {
        if (noOfUserOTPSend <= 2) {
            setIsResendAvailable(() => true);
            setOtpFormTimer(() => null);
            setOtpFormLoading(false);
        } else {
            setOtpFormLoading(false);
            setIsResetOtp(true);
            setIsResendAvailable(() => false);
            window.location.reload();
        }
    };

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: 999 }} open={otpFormLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {!showOTPForm ? (
                <>
                    <Login setOTPForm={setOTPForm} setIsUserAuthentic={setIsUserAuthentic} />

                    <Box>
                        <NavLink to={'/password-reset'} style={{ textDecoration: 'none' }}>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: 'secondary.main',
                                    fontWeight: 500,
                                    textAlign: 'right',
                                    mt: 0.5,
                                    mb: 1,
                                }}
                            >
                                Forgot Password ?
                            </Typography>
                        </NavLink>

                        <Typography
                            variant="subtitle1"
                            sx={{
                                color: 'textPrimary.main',
                                fontWeight: 400,
                                mb: 2,
                                textAlign: 'center',
                            }}
                        >
                            Don't have an account?
                        </Typography>

                        <Button
                            variant="outlined"
                            fullWidth
                            aria-label="Navigate to Sign Up page"
                            sx={{
                                borderRadius: 6,
                                py: 1,
                                fontWeight: 600,
                                fontSize: '1.125rem',
                                color: 'secondary.main',
                                borderColor: 'secondary.main',
                                textTransform: 'none', // optional: to keep "Sign Up" casing
                            }}
                            onClick={() => navigate('/signup', { replace: true })}
                        >
                            Sign Up
                        </Button>
                    </Box>
                </>
            ) : (
                <>
                    <OTPComponent
                        phone={isUserAuthentic?.mobile}
                        purpose="Login OTP"
                        isResendAvailable={isResendAvailable}
                        onVerifyOtp={handleOtpVerify}
                        onResendOtp={handleOtpResend}
                        isResetOtp={isResetOtp}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Timer initialTime={otpFormTimer} timeEnd={timerEnd} timerStyle={{}} />
                    </Box>
                </>
            )}
        </>
    );
};

export default LoginPage;
